import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="pp-container">
      <div className="pp-content">
        <h1 className="pp-title">Privacy Policy</h1>
        <p className="pp-last-modified">Last modified : January 2026</p>

        <p className="pp-intro">
          At True Renewables, we respect your privacy and are committed to protecting your
          personal data. This page explains how we collect, use, and safeguard your
          information when you visit our website or use our services.
        </p>

        <div className="pp-section">
          <h2>1. Information We Collect</h2>
          <p>We collect limited information to serve you better:</p>
          <ul>
            <li><strong>Personal details:</strong> Name, email, phone number (via contact forms or service inquiries).</li>
            <li><strong>Technical data:</strong> IP address, device type, browser info, and site usage (via analytics tools).</li>
            <li><strong>Project-related data:</strong> Details you share voluntarily for feasibility or solar project assessments.</li>
          </ul>
        </div>

        <div className="pp-section">
          <h2>2. How We Use Your Data</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Respond to inquiries and provide support.</li>
            <li>Prepare project proposals and feasibility reports.</li>
            <li>Improve our website and user experience.</li>
            <li>Send service updates or promotional offers (only with your consent).</li>
          </ul>
          <p>We do not sell or share your data with third parties for marketing.</p>
        </div>

        <div className="pp-section">
          <h2>3. Data Security</h2>
          <p>
            Your data is stored securely with encrypted systems and limited access. While we
            follow strict security protocols, no online system is 100% foolproof. We
            continuously update our practices to keep your data safe.
          </p>
        </div>

        <div className="pp-section">
          <h2>4. Cookies & Tracking</h2>
          <p>
            Our website uses cookies to enhance your browsing experience. Cookies help us
            understand how visitors interact with our site and improve usability. You can
            disable cookies anytime in your browser settings — though some features may not
            work as intended.
          </p>
        </div>

        <div className="pp-section">
          <h2>5. Sharing Information</h2>
          <p>We may share necessary data only with:</p>
          <ul>
            <li>Authorized vendors or service partners (for project delivery).</li>
            <li>Government or regulatory agencies (if legally required).</li>
            <li>IT and analytics providers who help us maintain the website.</li>
          </ul>
          <p>All partners handling your data are bound by strict confidentiality agreements.</p>
        </div>

        <div className="pp-section">
          <h2>6. Your Rights</h2>
          <p>You have full control over your personal data. You may:</p>
          <ul>
            <li>Request access to your data.</li>
            <li>Ask for corrections or updates.</li>
            <li>Request deletion of your personal information.</li>
            <li>Unsubscribe from communications at any time.</li>
          </ul>
          <p>
            To exercise these rights, email us at <a href="mailto:Care@truerenewables.in">Care@truerenewables.in</a>.
          </p>
        </div>

        <div className="pp-section">
          <h2>7. External Links</h2>
          <p>
            Our website may include links to external sites. Once you leave our domain, we are
            not responsible for how those websites handle your data.
          </p>
        </div>

        <div className="pp-section">
          <h2>8. Policy For Children</h2>
          <p>
            Our services are not intended for anyone under 18. We do not knowingly collect
            information from minors. If you believe a child has shared data with us, please
            contact us for immediate deletion.
          </p>
        </div>

        <div className="pp-section">
          <h2>9. Changes To This Policy</h2>
          <p>
            We may update this Privacy Policy periodically to reflect new regulations or
            business processes. Changes will be posted on this page, and the date will be
            updated above.
          </p>
        </div>

        <div className="pp-section">
          <h2>10. Contact Us</h2>
          <p>For any privacy-related questions or requests, contact us at:</p>
          <ul>
            <li><strong>Email:</strong> <a href="mailto:Care@truerenewables.in">Care@truerenewables.in</a></li>
            <li>
              <strong>Address:</strong> Plot No 1/C, Sy No 83/1, Raidurgam, Knowledge City Road, Panmaktha,
              Hyderabad – 500032
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
